<template>
  <div>
    <content-title title="重点排放单位基本信息" />
    <table class="table1" style="width: 100%">
      <tr>
        <th>重点排放单位名称</th>
        <td colspan="3">{{ baseCompanyInfo.companyName }}</td>
      </tr>
      <tr>
        <th>重点排放单位地址</th>
        <td colspan="3">{{ baseCompanyInfo.manufactureAddress }}</td>
      </tr>
      <tr>
        <th>
          {{
            baseCompanyInfo.codeType === "identity" ||
            baseCompanyInfo.codeType === "统一社会信用代码"
              ? "统一社会信用代码"
              : "组织机构代码/营业执照注册号"
          }}
        </th>
        <td>
          {{
            baseCompanyInfo.codeType === "identity" ||
            baseCompanyInfo.codeType === "统一社会信用代码"
              ? baseCompanyInfo.identityCode
              : baseCompanyInfo.organisationCode
          }}
        </td>
        <!-- <td>{{baseCompanyInfo.permitCode}}</td> -->
        <th>法定代表人</th>
        <td>{{ baseCompanyInfo.legalPerson }}</td>
      </tr>
      <tr>
        <th>联系人</th>
        <td>{{ baseCompanyInfo.monitorPlanMaker }}</td>
        <th>联系电话</th>
        <td>{{ baseCompanyInfo.monitorMakerPhone }}</td>
      </tr>
    </table>

    <content-title title="文件评审和现场核查过程" />
    <table class="table1" style="width: 100%">
      <tr>
        <th>核查技术工作组承担单位</th>
        <td>{{ lawFileSupervise.checkTechGroupUnit }}</td>
        <th>文件评审日期</th>
        <td>{{ lawFileSupervise.auditDate }}</td>
      </tr>
      <tr>
        <th>核查技术工作组成员</th>
        <td colspan="3">{{ lawFileSupervise.checkTechGroupMember }}</td>
      </tr>
      <tr>
        <th>现场核查工作组承担单位</th>
        <td>{{ siteCheckData.siteCheckUnit }}</td>
        <th>现场核查日期</th>
        <td>{{ siteCheckData.siteCheckDate }}</td>
      </tr>
      <tr>
        <th>现场核查工作组成员</th>
        <td colspan="3">{{ siteCheckData.siteGroupMember }}</td>
      </tr>
    </table>

    <content-title title="核查发现" v-if="conslusionType !== 'reviewFinish'" />
    <table
      class="table1"
      style="width: 100%;"
      v-if="conslusionType !== 'reviewFinish'"
    >
      <tr class="t-tr">
        <th>核查内容</th>
        <th>核查发现</th>
      </tr>
      <tr v-for="(v, k) in conclusionList" :key="k">
        <td>{{ k + 1 }}. {{ v.content }}</td>
        <td class="ta-l">
          <RadioGroup v-model="v.state">
            <Radio label="1" disabled>
              <span>符合要求</span>
            </Radio>
            <Radio label="2" disabled>
              <span>不符合项已整改且满足要求</span>
            </Radio>
            <Radio label="3" disabled>
              <span>不符合项整改但不满足要求</span>
            </Radio>
            <Radio label="4" disabled>
              <span>不符合项未整改</span>
            </Radio>
          </RadioGroup>
        </td>
      </tr>
    </table>

    <content-title title="核查确认" />
    <table class="table1" style="width: 100%;table-layout: fixed;">
      <tr>
        <th rowspan="2">温室气体排放报告（初次提交）日期</th>
        <td rowspan="2">
          <span>
            {{ unit.initialDate | getTime("Y") }}
          </span>
        </td>
        <th rowspan="2">初次提交报告中的排放量（tCO2e）</th>
        <!-- 非电力 -->
        <th v-if="!isElectricity">
          企业法人边界的温室气体排放总量（吨二氧化碳当量）
        </th>
        <td v-if="!isElectricity">
          <span>{{ unit.initGreenhouseEmission }}</span>
        </td>
        <!-- 电力 -->
        <td v-else rowspan="2" colspan="2">
          <span>{{ unit.initialEmissions }}</span>
        </td>
      </tr>

      <!-- 初次提交报告中的排放量（tCO2e）非电力分格 -->
      <tr>
        <th v-if="!isElectricity">
          按照补充数据核算报告模板填报的二氧化碳排放总量（吨）
        </th>
        <td v-if="!isElectricity">{{ unit.initialEmissions }}</td>
      </tr>

      <tr>
        <th>初次提交报告中与配额分配相关的生产数据</th>
        <td colspan="4" v-if="reportYear > 2020 && isElectricity">
          <div>
            <Table
              border
              :columns="columnsInitial"
              :data="initialProductInfoList"
            />
          </div>
        </td>
        <td v-else colspan="4">
          <Input
            disabled
            :autosize="{ minRows: 2, maxRows: 8 }"
            type="textarea"
            v-model="unit.initialProduction"
            maxlength="10000"
            show-word-limit
          />
        </td>
      </tr>

      <tr>
        <th rowspan="2">温室气体排放报告（最终）日期</th>
        <td rowspan="2">
          <DatePicker
            v-model="unit.endDate"
            type="date"
            format="yyyy-MM-dd"
            placeholder="请选择日期"
            disabled
          />
        </td>
        <th rowspan="2">经核查后的排放量（tCO2e）</th>
        <th v-if="!isElectricity">
          企业法人边界的温室气体排放总量（吨二氧化碳当量）
        </th>
        <td :colspan="isElectricity? 2 : 1">
          <Input
            v-if="!isElectricity"
            disabled
            v-model="unit.endGreenhouseEmission"
          />
          <div v-else>
            <p class="float-l" style="line-height:30px">
              {{ unit.endEmissions }}
            </p>
            <a
              class="float-r"
              @click="unitModal.show = true"
              style="line-height:30px"
              ><span style="color:red">*</span>详情</a
            >
          </div>
        </td>
      </tr>

      <!-- 经核查后按照补充数据核算报告模板填报的二氧化碳排放总量（吨） -->
      <tr>
        <th v-if="!isElectricity">
          按照补充数据核算报告模板填报的二氧化碳排放总量（吨）
        </th>
        <td v-if="!isElectricity">
          <Input
            v-if="!isElectricity"
            v-model="unit.endEmissions"
            type="number"
            disabled
            v-decimal="0"
          />
        </td>
      </tr>

      <tr>
        <th>经核查后与配额分配相关的生产数据</th>
        <td colspan="4" v-if="reportYear > 2020 && isElectricity">
          <div>
            <Table
              border
              :columns="columnsEnd"
              :data="endProductInfoList"
              class="endProductInfoTable"
            />
          </div>
        </td>
        <td v-else colspan="4">
          <Input
            disabled
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="unit.checkAfterProduction"
            maxlength="10000"
            show-word-limit
          />
        </td>
      </tr>

      <tr>
        <th>最终排放量的认定是否涉及核查技术工作组的测算？</th>
        <td colspan="4">
          <RadioGroup v-model="unit.isestimate">
            <Radio label="Y" disabled>
              <span>是</span>
            </Radio>
            <Radio label="N" disabled>
              <span>否</span>
            </Radio>
          </RadioGroup>
        </td>
      </tr>

      <tr>
        <th>
          关于排放量的说明（若选择是，简要说明原因、过程、依据和认定结果）
        </th>
        <td colspan="4">
          <Input
            disabled
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="unit.isestimateRemark"
            maxlength="1000"
            show-word-limit
          />
        </td>
      </tr>

      <tr>
        <th>
          最终与配额分配相关的生产数据的认定是否涉及核查技术工作组的测算？
        </th>
        <td colspan="4">
          <RadioGroup v-model="unit.isestimateProduct">
            <Radio label="Y" disabled>
              <span>是</span>
            </Radio>
            <Radio label="N" disabled>
              <span>否</span>
            </Radio>
          </RadioGroup>
        </td>
      </tr>

      <tr>
        <th>
          关于生产数据的说明（若选择是，简要说明原因、过程、依据和认定结果）
        </th>
        <td colspan="4">
          <Input
            disabled
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="unit.isestimateProductRemark"
            maxlength="1000"
            show-word-limit
          />
        </td>
      </tr>

      <tr>
        <th>其他需要说明的情况</th>
        <td colspan="4">
          <Input
            disabled
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            v-model="unit.other"
            maxlength="1000"
            show-word-limit
          />
        </td>
      </tr>
    </table>

    <content-title title="上传附件" />
    <Table :columns="fileCoulmns" :data="unitInfos" border>
      <template slot-scope="{ row }" slot="action">
        <a @click.prevent="fileDownload(row)">下载</a>
      </template>
    </Table>
    <div v-if="conslusionType!=='lawRectFinish'">
      <content-title title="复核说明" style="margin-top:20px" />
      <Input
        v-model="verifyReviewContent"
        :rows="8"
        maxlength="3000"
        show-word-limit
        type="textarea"
        :disabled="conslusionEdit === 'view'"
      />
    </div>

    <div class="footer" v-if="conslusionEdit !== 'view'">
      <Button
        type="primary"
        class="btn-c-common"
        @click="submitModal.show = true"
        >申请复核</Button
      >
    </div>

    <Modal v-model="submitModal.show">
      <p slot="header">{{ submitModal.title }}</p>
      <p class="indentation-2">
        请确认该核查结论不准确，需要向省级主管部门发起复核申请？
      </p>
      <p class="indentation-2">申请发起后无法撤销；</p>
      <p class="indentation-2">主管部门会在收到申请5个工作日内予以回复</p>
      <div slot="footer">
        <Button type="text" @click="submitModal.show = false">取消</Button>
        <Button
          class="btn-c-common"
          type="primary"
          @click="handleSubmit"
          :loading="btnLoading.handleSubmit"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal v-model="unitModal.show" width="700">
      <p slot="header">{{ unitModal.title }}</p>
      <div>
        <table class="table1" style="width: 100%">
          <tr>
            <th>机组</th>
            <th>排放量（tCO2e）</th>
            <th>汽轮机排汽冷却方式的补充说明</th>
          </tr>
          <tr v-for="(item, index) in unitEmissionsList" :key="index">
            <td>{{ item.unitName }}</td>
            <td><Input v-model="item.endEmissions" disabled /></td>
            <td>
              <CheckboxGroup :vertical='false' v-model="item.unitType">
                <Checkbox label="1" v-if="item.unitType==='1'" disabled>
                  <span>否</span>
                </Checkbox>
                <Checkbox label="5" disabled>
                  <span>水冷</span>
                </Checkbox>
                <Checkbox label="6" disabled>
                  <span>空冷</span>
                </Checkbox>
                <Checkbox label="2" disabled>
                  <span>背压机组</span>
                </Checkbox>
                <Checkbox label="3" disabled>
                  <span>内燃机组</span>
                </Checkbox>
                <Checkbox label="4" disabled>
                  <span>其他特殊机组</span>
                </Checkbox>
              </CheckboxGroup>
              <Input
                v-if="item.unitType == '4'"
                v-model="item.otherUnitName"
                disabled
              />
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>{{ unit.endEmissions }}</td>
          </tr>
        </table>
      </div>
      <div slot="footer">
        <Button
          class="btn-c-common"
          type="primary"
          @click="unitModal.show = false"
          :loading="btnLoading.unitModalOk"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import contentTitle from "@/components/comment/content-title.vue";

import {
  verifyReviewDetail,
  getCompanyDetail,
  verifyReviewSubmit,
} from "@/api/emissions-report.js";
import { downloadAttachments } from "@/api/file";

import { getTime } from "@/lib/util";

export default {
  components: {
    contentTitle,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    companyId() {
      return this.getUserInfo.user.companyId;
    },
    reportId() {
      return this.getUserInfo.user.reportId;
    },
    conslusionEdit() {
      return this.getUserInfo.user.conslusionEdit;
    },
    conslusionType() {
      return this.getUserInfo.user.conslusionType;
    },
    // true:发点企业 false：非发电
    isElectricity() {
      return this.$store.state.industry.isElectricity;
    },
    reportYear() {
      return this.getUserInfo.user.reportYear;
    },
    conclusionList(){
      if (this.conslusionType === 'lawRectFinish') {
          return [
                 {
                   content: "重点排放单位基本情况",
                   state: "1",
                   key: "basicSituationVal",
                 },
                 { content: "核算边界", state: "1", key: "accountingBoundaryVal" },
                 { content: "核算方法", state: "1", key: "accountingMethodVal" },
                 { content: "核算数据", state: "1", key: "accountingDataVal" },
                 { content: "质量控制和文件存档", state: "1", key: "qualityManageVal" },
                 {
                   content: "数据质量控制计划及执行",
                   state: "1",
                   key: "monitorPlanVal",
                 },
                 { content: "其他内容", state: "1", key: "otherContentVal" },
               ]
      } else {
          return [
            {
              content: "重点排放单位基本情况",
              state: "1",
              key: "basicSituationFind",
            },
            { content: "核算边界", state: "1", key: "accountingBoundaryFind" },
            { content: "核算方法", state: "1", key: "accountingMethodFind" },
            { content: "核算数据", state: "1", key: "accountingDataFind" },
            { content: "质量控制和文件存档", state: "1", key: "qualityManageFind" },
            {
              content: "数据质量控制计划及执行",
              state: "1",
              key: "monitorPlanFind",
            },
            { content: "其他内容", state: "1", key: "otherContent" },
          ]
      }

    },
  },
  data() {
    return {
      lawConclusion: {},
      submitModal: {
        title: "申请复核",
        show: false,
      },
      unitEmissionsList: [],
      unitModal: {
        title: "各机组排放量",
        show: false,
        totalEmissions: 0,
      },
      verifyReviewContent: "", // 复核说明
      unit: {
        lawId: "",
        initialDate: "",
        initialEmissions: "",
        initialProduction: "",
        endDate: "",
        endEmissions: "0",
        checkAfterProduction: "",
        isestimate: "",
        isestimateRemark: "",
        isestimateProduct: "",
        isestimateProductRemark: "",
        other: "",
      },
      btnLoading: {
        handleSubmit: false,
        unitModalOk: false,
      },
      baseCompanyInfo: {
        companyName: "",
        manufactureAddress: "",
        legalPerson: "",
        monitorPlanMaker: "",
        monitorMakerPhone: "",
        monitorEmail: "",
        codeType: "",
        identityCode: "",
        organisationCode: "",
      },
      // 现场核查
      siteCheckData: {},
      lawFileSupervise: {},

      // conclusionList: [
      //   {
      //     content: "重点排放单位基本情况",
      //     state: "1",
      //     key: "basicSituationFind",
      //   },
      //   { content: "核算边界", state: "1", key: "accountingBoundaryFind" },
      //   { content: "核算方法", state: "1", key: "accountingMethodFind" },
      //   { content: "核算数据", state: "1", key: "accountingDataFind" },
      //   { content: "质量控制和文件存档", state: "1", key: "qualityManageFind" },
      //   {
      //     content: "数据质量控制计划及执行",
      //     state: "1",
      //     key: "monitorPlanFind",
      //   },
      //   { content: "其他内容", state: "1", key: "otherContent" },
      // ],
      fileCoulmns: [
        { title: "附件名称", align: "center", key: "fileName" },
        { title: "上传时间", align: "center", key: "uploadTime" },
        { title: "操作", align: "center", slot: "action" },
      ],
      unitInfos: [],
      columnsInitial: [
        {
          title: "机组名称",
          key: "unitName",
          fixed: "left",
          width: 200,
        },
        {
          title: "主体燃料类型",
          key: "fuelType",
          width: 200,
        },
        {
          title: "装机容量",
          key: "capacity",
          width: 200,
        },
        {
          title: "机组类别范围",
          key: "categoryRange",
          width: 200,
        },
        {
          title: "产品类型",
          key: "mainProduct",
          width: 200,
        },
        {
          title: "供电量（MWh）",
          key: "infoItemGdl",
          width: 200,
        },
        {
          title: "供热量（GJ）",
          key: "infoItemGrl",
          width: 200,
        },
        {
          title: "供热比（%）",
          key: "infoItemGrb",
          width: 200,
        },
        {
          title: "排气冷却方式",
          key: "exhaustCoolingModeVal",
          width: 200,
        },
        {
          title: "负荷（出力）系数（%）",
          key: "infoItemFhclxs",
          width: 200,
        },
      ],
      initialProductInfoList: [],
      columnsEnd: [
        {
          title: "机组名称",
          key: "unitName",
          fixed: "left",
          width: 200,
        },
        {
          title: "主体燃料类型",
          key: "fuelType",
          width: 200,
        },
        {
          title: "装机容量",
          key: "capacity",
          width: 200,
        },
        {
          title: "机组类别范围",
          key: "categoryRange",
          width: 200,
        },
        {
          title: "产品类型",
          key: "mainProduct",
          width: 200,
        },
        {
          title: "供电量（MWh）",
          key: "infoItemGdl",
          width: 200,
        },
        {
          title: "供热量（GJ）",
          key: "infoItemGrl",
          width: 200,
        },
        {
          title: "供热比（%）",
          key: "infoItemGrb",
          width: 200,
        },
        {
          title: "排气冷却方式",
          key: "exhaustCoolingModeVal",
          width: 200,
        },
        {
          title: "负荷（出力）系数（%）",
          key: "infoItemFhclxs",
          width: 200,
        },
      ],
      endProductInfoList: [],
    };
  },
  created() {
    this.getCompanyDetail();
    this.getData();
  },
  methods: {
    async getCompanyDetail() {
      let params = {
        companyId: this.companyId,
        reportId: this.reportId,
      };
      const { status, body } = await getCompanyDetail(params);
      if (status === 200) {
        let tempData = body.companyInfo;
        const {
          companyName,
          manufactureAddress,
          codeType,
          organisationCode,
          identityCode,
          legalPerson,
          monitorPlanMaker,
          monitorMakerPhone,
          monitorEmail,
        } = tempData;
        this.baseCompanyInfo.companyName = companyName;
        this.baseCompanyInfo.manufactureAddress = manufactureAddress;
        this.baseCompanyInfo.legalPerson = legalPerson;
        this.baseCompanyInfo.monitorPlanMaker = monitorPlanMaker;
        this.baseCompanyInfo.monitorMakerPhone = monitorMakerPhone;
        this.baseCompanyInfo.monitorEmail = monitorEmail;
        this.baseCompanyInfo.codeType = codeType;
        this.baseCompanyInfo.codeType = codeType;
        this.baseCompanyInfo.identityCode = identityCode;
        this.baseCompanyInfo.organisationCode = organisationCode;
      }
    },
    async getData() {
      let params = {
        reportId: this.reportId,
        companyId: this.companyId,
      };
      const { status, body } = await verifyReviewDetail(params);
      if (status === 200) {
        let detailsInfo = body.lawConclusion;
        this.conclusionList.map((item) => {
          item.state = detailsInfo[item.key]
            ? detailsInfo[item.key]
            : item.state;
          return item;
        });
        this.lawFileSupervise = body.lawFileSupervise;
        this.siteCheckData = body.siteCheckData;
        this.unitInfos = body.fileInfos;
        body.unitEmissionsList.forEach(item=>{
          item.unitType = item.unitType.split(',')
        });
        this.unitEmissionsList = body.unitEmissionsList
        this.unit.initialDate = detailsInfo.initialDate;
        this.unit.initialEmissions = detailsInfo.initialEmissions;
        this.unit.initialProduction = detailsInfo.initialProduction;
        this.unit.endDate = getTime(detailsInfo.endDate, "Y");
        this.unit.endEmissions = detailsInfo.endEmissions;
        this.unit.checkAfterProduction = detailsInfo.checkAfterProduction;
        this.unit.isestimate = detailsInfo.isestimate;
        this.unit.isestimateRemark = detailsInfo.isestimateRemark;
        this.unit.isestimateProduct = detailsInfo.isestimateProduct;
        this.unit.isestimateProductRemark = detailsInfo.isestimateProductRemark;
        this.unit.initGreenhouseEmission = detailsInfo.initGreenhouseEmission;
        this.unit.endGreenhouseEmission = detailsInfo.endGreenhouseEmission;
        this.unit.other = detailsInfo.other;
        this.initialProductInfoList = body.initialProductInfoList;
        this.endProductInfoList = body.endProductInfoList;
        this.verifyReviewContent = body.verifyReviewContent;
      }
    },
    async handleSubmit() {
      this.btnLoading.handleSubmit = true;
      let parmas = {
        companyId: this.companyId,
        reportId: this.reportId,
        verifyReviewContent: this.verifyReviewContent,
      };
      if (parmas.verifyReviewContent.trim() === "") {
        this.$Message.warning("请填写复核说明");
        this.btnLoading.handleSubmit = false;
        this.submitModal.show = false;
        return;
      }
      const { status, message } = await verifyReviewSubmit(parmas);
      if (status === 200) {
        this.$Message.success("提交成功");
        this.$router.replace({ path: "/mian/report-list" });
      } else {
        this.$Message.success(message);
        this.btnLoading.handleSubmit = false;
      }
    },
    unitModalOk() {
      this.btnLoading.unitModalOk = true;
      this.unitModal.show = false;
    },
    async fileDownload(row) {
      let params = {
        fileCode: row.fileCode,
        fileName: row.fileName,
      };
      await downloadAttachments(params);
    },
  },
};
</script>

<style lang="less" scoped>
.table-after {
  overflow: auto;
  position: relative;
}
.table1 {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;

  th,
  td {
    border: 1px solid #e8eaec;
    padding: 10px;
  }

  th {
    background: #f8f8f9;
    text-align: center;
    min-width: 200px;
    font-weight: normal;
  }

  td {
    background-color: #fff;
    min-width: 200px;
  }
}
.footer {
  width: 100px;
  margin: 30px auto 0;
}
.option-btn {
  width: 100%;
  padding: 0 0 10px;
}
</style>
